import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import Moment from 'moment'
import { connect } from 'react-redux'

import { Get, Put, Post } from 'utils/axios'
import getDomainURL from 'utils/api'
import firebase from '../../../../firebase'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      newAppointment: {
        start_datetime: '',
        end_datetime: '',
        user_id: '',
        patient_id: '',
        status: '',
        details: '',
        is_incomplete_treatment: false,
        company_id: this.props.data.profileReducer.profile.current_user.company_ids.length > 0 && this.props.data.profileReducer.profile.current_user.branches.length > 0 
          ? this.props.data.profileReducer.profile.current_user.branches[0].company_id 
          : '',
        branch_id: this.props.data.profileReducer.profile.current_user.branches.length > 0 ? this.props.data.profileReducer.profile.current_user.branches[0].id : ''
      },
      selectedAppointment: {
        start_datetime: '',
        end_datetime: '',
        user_id: '',
        patient_id: '',
        status: '',
        details: '',
        is_incomplete_treatment: false,
        company_id: '',
        branch_id: ''
      },
      appointments: [],
      showCreateAppointment: false,
      showUpdateAppointment: false,
      selectedDoctorID: [],
      selectedBranchID: [],
      selectedPatientName: '',
      selectedTimeSlot: {
        starts: '',
        slots: []
      },
      appointmentsOffDates: [],
      showCancelledAppointments: false,
      selectedDate: ''
    }

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    onChangeAppointmentsHOC = ( key, val ) => this.setState({ [key]: val })

    getAppointments = ( user_id, branch_id, start_date, end_date ) => {
      let { current_user } = this.props.data.profileReducer.profile
      let tmpUserID = ''
      let tmpBranchID = ''
      let query = ''
      user_id.map( item => tmpUserID = tmpUserID + `q[user_id_in][]=${ item }&` )
      branch_id.map( item => tmpBranchID = tmpBranchID + `q[branch_id_in][]=${ item }&` )
      query = query + `${ this.state.selectedDoctorID.length === 0 ? '' : tmpUserID }`
      query = query + `${ this.state.selectedBranchID.length === 0 ? '' : tmpBranchID }`
      query = query + `${ this.state.selectedPatientName !== '' ? `q[patient_name_cont]=${ this.state.selectedPatientName }&` : '' }`
      // query = query + `q[start_datetime_gteq]=2021-5-16&q[end_datetime_lteq]=2021-5-17`
      query = query + `q[start_datetime_gteq]=${ start_date }&q[end_datetime_lteq]=${ end_date }`
      Get(
        `/appointments?${ query }`,
        this.getAppointmentsSuccess,
        this.getAppointmentsError,
        this.load
      )
    }
    
    getAppointmentsSuccess = payload => {
      let tmp = []
      let tmpDates = []
      payload.map( item => {
        tmp.push({ 
          ...item,
          start_datetime: new Date( item.start_datetime ),
          end_datetime: new Date( item.end_datetime ),
          title: `${ item.user_salutation } ${ item.user_name } - ${ item.patient_name } - ${ item.patient_contact_number } - ${ item.details }`,
          resourceId: item.user_id
        })
        tmpDates.push({
          user_id: item.user_id,
          offDatetime: new Date( item.start_datetime ) })
      })
      this.props.offDatesObjects.map( item => {
        tmp.push( item )
      })
      this.setState({ appointments: tmp, appointmentsOffDates: tmpDates })
    }
    getAppointmentsError = error => this.requestError( error )

    getSelectedAppointment = id => Get(
      `/appointments/${ id }`,
      this.getSelectedAppointmentSuccess,
      this.getSelectedAppointmentError,
      this.load
    )
    getSelectedAppointmentSuccess = payload => this.setState({ 
      showUpdateAppointment: true, 
      selectedAppointment: {
        ...payload,
        start_datetime: new Date( payload.start_datetime ),
        end_datetime: new Date( payload.end_datetime )
      }
    })
    getSelectedAppointmentError = error => this.requestError( error )

    createAppointment = data => Post(
      `/appointments`,
      data,
      this.createAppointmentSuccess,
      this.createAppointmentError,
      this.load
    )
    createAppointmentSuccess = payload => {
      this.setState({ 
        showCreateAppointment: false, 
        newAppointment: {
          start_datetime: '',
          end_datetime: '',
          user_id: '',
          patient_id: '',
          status: '',
          details: '',
          is_incomplete_treatment: false,
          company_id: this.props.data.profileReducer.profile.current_user.company_ids.length > 0 && this.props.data.profileReducer.profile.current_user.branches.length > 0 
            ? this.props.data.profileReducer.profile.current_user.branches[0].company_id 
            : '',
          branch_id: this.props.data.profileReducer.profile.current_user.branches.length > 0 ? this.props.data.profileReducer.profile.current_user.branches[0].id : ''
        }
      }, () => {
        this.requestSuccess( 'Appointment is created successfully.' )
        this.getAppointments( 
          this.state.selectedDoctorID.length > 0 
            ? this.state.selectedDoctorID.map( dr => dr.id )
            : [],
          this.state.selectedBranchID.length > 0 ? this.states.selectedBranchID.map( branch => branch.id ) : [],
          Moment( this.state.selectedDate ).clone().startOf('month').format( 'YYYY-MM-DD' ), 
          Moment( this.state.selectedDate ).clone().endOf('month').add( 1, 'days' ).format( 'YYYY-MM-DD' )
        )
      })
    }
    createAppointmentError = error => this.requestError( error )

    updateAppointment = ( data, frontDeskId, patientName, isMedicalRecord ) => Put(
      `/appointments/${ data.id }`,
      data,
      payload => this.updateAppointmentSuccess( payload, frontDeskId, patientName, isMedicalRecord ),
      this.updateAppointmentError,
      this.load
    )
    updateAppointmentSuccess = ( payload, frontDeskId, patientName, isMedicalRecord ) => {
      this.setState({ 
        // showUpdateAppointment: true, 
        // selectedAppointment: {
        //   start_time: '',
        //   end_time: '',
        //   user_id: '',
        //   patient_id: '',
        //   status: '',
        //   details: '',
        //   company_id: ''
        // }
      }, () => {
        this.requestSuccess( 'Appointment is updated successfully.' )
        if( !_.isEmpty( patientName ) && !isMedicalRecord ){
          this.sendFirebaseNotificationToDr( frontDeskId, patientName, payload ) 
        }
        this.getAppointments( 
          this.state.selectedDoctorID.length > 0 
            ? this.state.selectedDoctorID.map( dr => dr.id )
            : [],
          this.state.selectedBranchID.length > 0 ? this.state.selectedBranchID.map( branch => branch.id ) : [],
          Moment( this.state.selectedDate ).clone().startOf('month').format( 'YYYY-MM-DD' ), 
          Moment( this.state.selectedDate ).clone().endOf('month').add( 1, 'days' ).format( 'YYYY-MM-DD' )
        )
      })
    }
    updateAppointmentError = error => this.requestError( error )

    sendFirebaseNotificationToDr = ( frontDeskId, patientName, selectedAppointment ) => {
      let successMessage = 'Notification is sent. Doctor can now check the patient\'s detail'
      let notification =  {
        frontDeskId: frontDeskId,
        created_at: Moment().format(),
        message: `<p>Hey doctor, ${ patientName } ( patient ) is coming in, click <a href='${ 
          getDomainURL().indexOf( 'staging' ) > -1
            ? 'https://app-staging.primeview.site'
            : window.location.origin }/#/dashboard/patients/${ selectedAppointment.patient_id }'>here</a> to view his/her medical record.</p>` 
      }
      let firebaseNotification = {
        notification: {
          title: 'New Medical Record',
          body: notification,
          click_action: `${ getDomainURL().indexOf( 'staging' ) > -1
            ? 'https://app-staging.primeview.site'
            : window.location.origin }/#/dashboard/patients/${ selectedAppointment.patient_id }`,
          icon: 'data:image/png;base64,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',
        },
        to: ''
      }
      const userRef = getDomainURL().indexOf( 'staging' ) > -1
        ? firebase.database().ref( `stagingUsers/${ selectedAppointment.user_id }` ) 
        : getDomainURL().indexOf( 'idr' ) > -1
          ? firebase.database().ref( `productionUsersIdr/${ selectedAppointment.user_id }` ) 
          : firebase.database().ref( `productionUsers/${ selectedAppointment.user_id }` ) 
          
      userRef.once( 'value', snapshot => {
        let tmpNotificationList = []
        tmpNotificationList.push( notification )
        if( snapshot.exists() ){
          let tmpUser = {}
          if( snapshot.hasChild( 'token' ) ){
            tmpUser.token = snapshot.val().token
            firebaseNotification.to = snapshot.val().token
          }
          if( snapshot.hasChild( 'notifications' ) ){
            for( let id in snapshot.val().notifications ){
              tmpNotificationList.push( snapshot.val().notifications[ id ] )
            }
          }
          tmpUser.notifications = tmpNotificationList
          // userRef.set( tmpUser, () => this.sendNotification( firebaseNotification ) )
          userRef.set( tmpUser ).then( () => {
            this.requestSuccess( successMessage )
          })
        }
        else {
          let tmpUser = { notifications: tmpNotificationList  }
          userRef.set( tmpUser ).then( () => {
            this.requestSuccess( successMessage )
          })
        }
      })
    }

    render = () => {
      return (
        <WrappedComponent 
          { ...this.props }
          showCreateAppointment={ this.state.showCreateAppointment }
          showUpdateAppointment={ this.state.showUpdateAppointment }
          newAppointment={ this.state.newAppointment }
          selectedAppointment={ this.state.selectedAppointment }
          onLoadAppointments={ this.state.loading }
          selectedDoctorID={ this.state.selectedDoctorID }
          selectedBranchID={ this.state.selectedBranchID }
          selectedPatientName={ this.state.selectedPatientName }
          appointments={ this.state.appointments }
          selectedTimeSlot={ this.state.selectedTimeSlot }
          appointmentsOffDates={ this.state.appointmentsOffDates }
          onChangeAppointmentsHOC={ this.onChangeAppointmentsHOC }
          getAppointments={ this.getAppointments }
          getSelectedAppointment={ this.getSelectedAppointment }
          createAppointment={ this.createAppointment }
          updateAppointment={ this.updateAppointment }
          showCancelledAppointments={ this.state.showCancelledAppointments }
          selectedDate={ this.state.selectedDate } />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC